<template>
    <q-list>
        <q-collapsible class="filter" icon="fas fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
            <q-list no-border>
                <q-item>
                    <q-item-main>
                        <q-search v-model="search" :placeholder="$t('search')" icon="fas fa-search" @input="changeFilter('search')" :debounce="600" />
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list v-if="areas.length" no-border link>
                <q-list-header>{{ $t('areas') }}</q-list-header>

                <q-item tag="label" v-for="(area, index) in areas" :key="index">
                    <q-item-side>
                        <q-radio v-model="selected_areas" :val="area.value" @input="changeFilter('areas')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ area.label }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list v-else no-border link>
                <q-list-header>{{ $t('areas') }}</q-list-header>

                <q-item tag="label">
                    <q-item-side>
                        <q-radio v-model="selected_areas" val="all" @input="changeFilter('areas')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ $t('all_f') }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link v-if="categories.length > 0">
                <q-list-header>{{ $t('categories') }}</q-list-header>

                <q-item tag="label">
                    <q-item-side>
                        <q-radio v-model="selected_categories" val="all" @input="changeFilter('categories')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ $t('all_f') }}</q-item-tile>
                    </q-item-main>
                </q-item>

                <q-item tag="label" v-for="(category, index) in categories" :key="index">
                    <q-item-side>
                        <q-radio v-model="selected_categories" :val="category.value" @input="changeFilter('categories')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ category.label }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link v-if="tags.length > 0">
                <q-list-header>{{ $t('tags') }}</q-list-header>

                <q-item tag="label" v-for="(tag, index) in tags" :key="index">
                    <q-item-side>
                        <q-checkbox v-model="selected_tags" :val="tag.value" @input="changeFilter('tags')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ tag.label }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link>
                <q-list-header>{{ $t('groups') }}</q-list-header>

                <q-item tag="label">
                    <q-item-side>
                        <q-radio v-model="selected_groups" val="all" @input="changeFilter('groups')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ $t('all') }}</q-item-tile>
                    </q-item-main>
                </q-item>

                <q-item tag="label" v-for="(group, index) in groups_user" :key="index">
                    <q-item-side>
                        <q-radio v-model="selected_groups" :val="group.value" @input="changeFilter('groups')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light">{{ group.label }}</q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link>
                <q-list-header>{{ $t('extensions') }}</q-list-header>

                <q-item tag="label" v-for="(extension, index) in extensions" :key="index">
                    <q-item-side>
                        <q-checkbox v-model="selected_extensions" :val="extension" @input="changeFilter('extension')" />
                    </q-item-side>
                    <q-item-main>
                        <q-item-tile label class="text-weight-light uppercase">
                            <q-icon :name="$extensionIcon(extension)" size="1.5rem" /> {{ extension }}
                        </q-item-tile>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border link>
                <q-item>
                    <q-item-main>
                        <p class="text-center">
                            <a href="#" @click.prevent="clearFilters()" class="text-faded">
                                <q-icon name="far fa-trash-alt" /> {{ $t('clear_filters') }}
                            </a>
                        </p>
                    </q-item-main>
                </q-item>
            </q-list>

        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'
export default {

    data() {
        return {
            search: '',
            selected_areas: 'all',
            selected_groups: '',
            selected_categories: 'all',
            selected_tags: [],
            selected_extensions: [],
            areas: [],
            categories: [],
            tags: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            search_store: 'libraries/search',
            extensions: 'site_lists/library_file_extensions',
            store_search: 'libraries/search',
            store_selected_areas: 'libraries/selected_areas',
            store_selected_categories: 'libraries/selected_categories',
            store_selected_groups: 'libraries/selected_groups',
            store_selected_tags: 'libraries/selected_tags',
            store_selected_extensions: 'libraries/selected_extensions',
            groups_user: 'site_lists/groups_user',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        fetchAreas() {
            this.$axios.get('/etraining_library_files/files/areas_filter/', this.getHeader)
            .then(response => {
                this.areas = response.data ? response.data.map(a => {
                    return { label: a.name, value: a.id }
                }) : []
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchCategories() {
            if (this.selected_areas != 'all') {
                this.$axios.get(`/etraining_library_files/files/area_categories_filter/?areas=${this.selected_areas}`, this.getHeader)
                .then(response => {
                    response.data.map(a => {
                        this.categories.push({ label: a.title, value: a.id })
                    })
                })
            }
        },

        fetchTags() {
            let url = ''
            if (this.selected_categories !== 'all') {
                url = `/etraining_library_files/files/area_category_tags_filter/?categories=${this.selected_categories}`
            } else {
                url = '/etraining_library_files/files/area_category_tags_filter/'
            }
            this.$axios.get(url, this.getHeader)
            .then(response => {
                response.data.map(a => {
                    this.tags.push({ label: a.title, value: a.id })
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        changeFilter(type) {
            if (type === 'areas') {
                this.categories = []
                this.selected_categories = 'all'
                this.selected_groups = ''
                this.tags = []
                this.selected_tags = []

                this.fetchCategories()
            }
            else if (type === 'categories') {
                this.tags = []
                this.selected_tags = []

                this.fetchTags()
            }
            else if (type === 'groups') {
                this.categories = []
                this.selected_categories = 'all'
                this.selected_areas = ''
                this.tags = []
                this.selected_tags = []
            }

            this.$store.dispatch('libraries/SET_FILTERS', [this.search, this.selected_areas, this.selected_categories, this.selected_groups, this.selected_tags, this.selected_extensions])
            this.$emit('changeFilter')
        },

        clearFilters() {
            this.$store.dispatch('libraries/SET_FILTERS', ['', 'all', 'all', '', [], []])
            this.$emit('changeFilter')
            this.search =  '',
            this.selected_areas =  'all',
            this.selected_categories =  'all',
            this.selected_tags =  [],
            this.selected_extensions =  [],
            this.selected_groups = ''
            // this.areas =  [],
            // this.categories =  [],
            // this.tags =  []
        },

        getExtensionIcon(ext) {
            switch(ext) {
                case 'mp4': return 'far fa-file-video'
                break

                case 'pdf': return 'far fa-file-pdf'
                break

                case 'png':
                case 'jpg':
                case 'gif': return 'far fa-file-image'
                break

                case 'zip':
                case 'rar':
                case 'gzip':
                case 'tz': return 'far fa-file-archive'
                break

                case 'xlsx':
                case 'xls': return 'far fa-file-excel'
                break

                case 'docx':
                case 'doc': return 'far fa-file-word'
                break

                case 'pptx':
                case 'ppt': return 'far fa-file-powerpoint'

                default: return 'far fa-file'
                break
            }
        }
    },

    created() {
        this.fetchAreas()

        this.search = this.store_search

        this.selected_areas = this.store_selected_areas
        this.selected_categories = this.store_selected_categories
        this.selected_tags = Object.assign([], this.store_selected_tags)
        this.selected_extensions = Object.assign([], this.store_selected_extensions)

        if (this.selected_areas != 'all') this.fetchCategories
        if (this.selected_categories != 'all') this.fetchTags
        if (this.selected_areas && this.selected_areas !== 'all') {
            this.fetchCategories()
        }
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

p
    &.tags
        margin 0 0 5px

a
    text-decoration none
</style>
